export type PromptVersionTextSnapshot = {
  readonly version: number;
  readonly text: string;
};

/**
 * Returns the prompt text from the snapshot immediately before the target version.
 * @param versions Snapshots keyed by version number (order does not matter).
 * @param targetVersion The version whose prior snapshot should be returned.
 * @returns The previous version's text, or null when there is no N−1 row.
 */
export function getPreviousPromptVersionText(
  versions: readonly PromptVersionTextSnapshot[],
  targetVersion: number,
): string | null {
  const previousVersion = targetVersion - 1;
  if (previousVersion < 1) {
    return null;
  }

  const previous = versions.find((entry) => entry.version === previousVersion);
  return previous?.text ?? null;
}
